// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  stamp: __t.string(),
  adminOrgId: __t.string(),
  isHouse: __t.bool(),
  issuers: __t.array(__t.string()),
  webclientBaseUrl: __t.string(),
  githubAppInstallUrl: __t.string(),
  repoOwner: __t.string(),
  repoName: __t.string(),
  defaultLabels: __t.string(),
  installationId: __t.u64(),
  crossDeploymentSupport: __t.bool(),
};
